(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swap-3-collections"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.collection-tab-btn').forEach(button => {
  button.addEventListener('click', () => {
    document.querySelectorAll('.collection-tab-btn').forEach(btn => btn.classList.remove('active'));
    document.querySelectorAll('.collection-tab-content').forEach(tab => tab.classList.remove('active'));
    document.querySelectorAll('.shop-btn-wrapper').forEach(btn => btn.style.display = "none");

    button.classList.add('active');
    document.getElementById(button.dataset.tab).classList.add('active');
    document.getElementById('btn-' + button.dataset.tab).style.display = "block";
  });
});

  } catch(e) { console.error(e); }
})();
})();
